class MrPoetikCountdown {
  constructor(element) {
    this.element = element;
    this.completeMessage = element.querySelector('.mrpoetik-countdown__complete');
    this.timer = null;
    this.redirectAfterLaunch = element.dataset.redirectAfterLaunch === 'true';
    this.redirectUrl = element.dataset.redirectUrl;
    this.redirectKey = `mrpoetik-countdown-redirect-${element.dataset.launchDate || ''}-${element.dataset.launchTime || ''}`;
    this.launchAt = this.getLaunchDate();
    if (this.launchAt) this.start();
  }

  getLaunchDate() {
    const { launchDate, launchTime, launchTimezone } = this.element.dataset;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(launchDate || '') || !/^\d{2}:\d{2}$/.test(launchTime || '')) return null;

    const [year, month, day] = launchDate.split('-').map(Number);
    const [hour, minute] = launchTime.split(':').map(Number);
    const provisionalUtc = Date.UTC(year, month - 1, day, hour, minute);
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: launchTimezone || 'Europe/Berlin',
      timeZoneName: 'longOffset',
    }).formatToParts(new Date(provisionalUtc));
    const offset = parts.find((part) => part.type === 'timeZoneName')?.value || 'GMT+00:00';
    const match = offset.match(/GMT([+-])(\d{2}):(\d{2})/);
    const offsetMinutes = match ? (Number(match[2]) * 60 + Number(match[3])) * (match[1] === '+' ? 1 : -1) : 0;
    return new Date(provisionalUtc - offsetMinutes * 60 * 1000);
  }

  start() {
    const render = () => {
      const remaining = Math.max(0, this.launchAt.getTime() - Date.now());
      const units = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining / 3600000) % 24),
        minutes: Math.floor((remaining / 60000) % 60),
        seconds: Math.floor((remaining / 1000) % 60),
      };

      Object.entries(units).forEach(([unit, value]) => {
        const target = this.element.querySelector(`[data-countdown-${unit}]`);
        if (target) target.textContent = String(value).padStart(2, '0');
      });

      if (remaining === 0) {
        window.clearInterval(this.timer);

        if (this.redirectAfterLaunch && this.redirectUrl && !this.hasRedirected()) {
          this.markRedirected();
          window.location.replace(this.redirectUrl);
          return;
        }

        this.completeMessage?.removeAttribute('hidden');
        this.element.classList.add('is-launched');
        this.element.querySelector('[data-after-launch]')?.removeAttribute('hidden');
      }
    };

    render();
    this.timer = window.setInterval(render, 1000);
  }

  hasRedirected() {
    try {
      return window.sessionStorage.getItem(this.redirectKey) === '1';
    } catch {
      return false;
    }
  }

  markRedirected() {
    try {
      window.sessionStorage.setItem(this.redirectKey, '1');
    } catch {
      // Browsers that block session storage can still perform the one-off redirect.
    }
  }
}

document.querySelectorAll('[data-mrpoetik-countdown]').forEach((element) => new MrPoetikCountdown(element));
